<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useAuthStore } from "@/modules/auth/stores/auth";
import { usePusher } from "@/shared/composables/usePusher";
import GlobalModal from "@/shared/components/GlobalModal.vue";
import { useRouter, useRoute } from "vue-router";

const authStore = useAuthStore();
const { initPusher } = usePusher();
const router = useRouter();
const route = useRoute();
const isReady = ref(false);

// Track navigation direction for directional transitions
const routeStack = ref<string[]>([]);
const transitionName = ref("fade");

router.afterEach((to) => {
    const idx = routeStack.value.indexOf(to.path);
    if (idx >= 0) {
        // Navigating back — pop stack
        routeStack.value = routeStack.value.slice(0, idx);
        transitionName.value = "slide-left";
    } else {
        // Navigating forward — push stack
        routeStack.value.push(to.path);
        transitionName.value = "slide-right";
    }
});

onMounted(async () => {
    await authStore.checkAuth();

    if (authStore.isLoggedIn && authStore.user) {
        initPusher(authStore.user.id, authStore.token);
    }

    isReady.value = true;
});
</script>

<template>
    <div v-if="!isReady" class="flex items-center justify-center h-screen">
        <div class="text-lg text-text-gray">Loading...</div>
    </div>

    <template v-else>
        <router-view v-slot="{ Component }">
            <transition :name="transitionName" mode="out-in">
                <component :is="Component" :key="route.path" />
            </transition>
        </router-view>
        <GlobalModal />
    </template>
</template>